import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["value", "disabled"]
const _hoisted_3 = {
  key: 1,
  value: ""
}
const _hoisted_4 = ["value"]

import { ref, watch } from 'vue';

interface SelectProps {
    /**
     * Items that will be used as dropdown source
     */
    items: { id: number | string, text: number | string }[],
    id?: string,
    modelValue: any,
    defaultValue?: string | number,
    defaultMessage?: string,
    disableDefaultOption?: boolean,
    /**
     * The callback that is invoked on selection change
     */
    // eslint-disable-next-line no-unused-vars
    onChange?: (data?: any) => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VueSelect',
  props: {
    items: {},
    id: {},
    modelValue: {},
    defaultValue: {},
    defaultMessage: {},
    disableDefaultOption: { type: Boolean },
    onChange: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const localModel = ref(props.modelValue);
// watch(localModel, v => {
//     emit('update:modelValue', v);
//     if (props.onChange) {
//         props.onChange(v);
//     }
// });

const handleSelectionChange = (event: Event) => {
    const newSelectionValue = (event.target as HTMLSelectElement).value;
    emit('update:modelValue', newSelectionValue);
    if (props.onChange) {
        props.onChange(newSelectionValue);
    }
}

// parent value changes by other way
watch(props, v => localModel.value = v.modelValue);


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    id: props.id,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModel).value = $event)),
    onChange: handleSelectionChange
  }, [
    (props.defaultValue !== undefined && props.defaultMessage)
      ? (_openBlock(), _createElementBlock("option", {
          key: 0,
          value: __props.defaultValue,
          disabled: props.disableDefaultOption
        }, _toDisplayString(props.defaultMessage), 9, _hoisted_2))
      : (_openBlock(), _createElementBlock("option", _hoisted_3, "Please select")),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
      return (_openBlock(), _createElementBlock("option", {
        key: item.id,
        value: item.id
      }, _toDisplayString(item.text), 9, _hoisted_4))
    }), 128))
  ], 40, _hoisted_1)), [
    [_vModelSelect, localModel.value]
  ])
}
}

})